import { useState } from 'react';
import { Text } from 'foundations-components/components/Text';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import H5 from 'UIComponents/elements/headings/H5';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
// @ts-expect-error migrate dependency

import { getDescription, getLabel
// @ts-expect-error migrate dependency
} from '../../../../lib/dashboardFilters/propertySchema';
import { getDefaultOperatorForProperty } from 'platform-dashboard-ui/filter/utils/dataSourceHelpers';
import PinnedPropertyFilterInputFooter from './PinnedPropertyFilterInputFooter';
import { AsyncQuickFilterGroupFilterOperatorCRMInput as QuickFilterGroupFilterOperatorCRMInput } from 'platform-dashboard-ui/components/quickFilterGroup/filter/AsyncQuickFilterGroupFilterOperatorCRMInput';
import { validateFilterOperator } from 'platform-dashboard-ui/filter/utils/filterEditorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PinnedPropertyCRMInput = ({
  dataSource,
  onApplyFilter,
  property,
  prevOperator = null,
  userHasQuickFilterEditPermission = false,
  dashboardId
}) => {
  const [selectedOperator, setSelectedOperator] = useState(prevOperator || getDefaultOperatorForProperty(dataSource, property));
  const {
    isValid
  } = validateFilterOperator(selectedOperator);
  const handleApplyFilter = () => {
    onApplyFilter(selectedOperator);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ScrollContainer, {
      maxHeight: "100%",
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-0",
        children: getLabel(property)
      }), /*#__PURE__*/_jsx(UIExpandableText, {
        className: "m-bottom-3",
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: getDescription(property)
        })
      }), /*#__PURE__*/_jsx(QuickFilterGroupFilterOperatorCRMInput, {
        groupDefinedProperty: property,
        groupDefinedPropertyDataSourceId: dataSource,
        selectedOperator: selectedOperator,
        onSelectOperator: setSelectedOperator
      })]
    }), /*#__PURE__*/_jsx(PinnedPropertyFilterInputFooter, {
      onApplyFilter: handleApplyFilter,
      dataSource: dataSource,
      property: property,
      userHasQuickFilterEditPermission: userHasQuickFilterEditPermission,
      dashboardId: dashboardId,
      isValid: isValid
    })]
  });
};